import { Button } from '../ui/button';
import { LinkedinLogo, Copy } from '@phosphor-icons/react';
import { toast } from 'sonner';
import { BACKEND_URL } from './adminConstants';

/**
 * Renders a small "Copy LinkedIn link" button. The copied URL goes to the
 * backend `/api/og/{type}/{slug}` endpoint which serves HTML with proper
 * per-article OG meta tags (image, title, excerpt) so LinkedIn shows the
 * right preview. The visitor's browser is then auto-redirected to the
 * real article URL.
 */
export function ShareLinkedInButton({ type, slug, label = 'Copy LinkedIn link' }) {
  const shareUrl = `${BACKEND_URL}/api/og/${type}/${slug}`;

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      toast.success('LinkedIn-ready link copied to clipboard');
    } catch {
      // Older browsers / iframe contexts
      const ta = document.createElement('textarea');
      ta.value = shareUrl;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); toast.success('Link copied'); }
      catch { toast.error('Could not copy — your browser blocked clipboard access'); }
      document.body.removeChild(ta);
    }
  };

  return (
    <Button
      variant="outline"
      size="sm"
      onClick={handleCopy}
      className="border-[#0a66c2]/30 text-[#0a66c2] hover:bg-[#0a66c2]/5"
      data-testid={`share-linkedin-${slug}`}
      title={shareUrl}
    >
      <LinkedinLogo size={14} weight="fill" className="mr-1" />
      <Copy size={11} weight="bold" className="mr-1" />
      {label}
    </Button>
  );
}
